import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { BulkPutOrderRequest, UpdateOrderInfoRequest } from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * 発注のreminderMailDataIdを更新するUseCase
 */
export class UpdateOrderReminderMailIdUseCase {
  private orderRepository: IOrderRepository;

  /**
   * コンストラクタ
   * @param orderRepository - 発注リポジトリ
   */
  constructor(orderRepository: IOrderRepository) {
    this.orderRepository = orderRepository;
  }

  /**
   * 発注のreminderMailDataIdを更新する（単一件）
   * @param orderId - 発注ID
   * @param reminderMailDataId - リマインドメールデータID（nullの場合はクリア）
   * @param updateAt - 更新時刻（CONFLICTチェック用）
   * @param orderNote - 発注メモ（リマインドメール本文を保存）
   * @returns 更新結果
   */
  async Execute(
    orderId: string,
    reminderMailDataId: string | null,
    updateAt: number,
    orderNote?: string
  ): Promise<INetworkResult<any, IError>> {
    const request: UpdateOrderInfoRequest = {
      putOrderInfo: {
        orderId,
        reminderMailDataId,
        orderNote,
        updateAt,
      },
    };

    try {
      const result = await this.orderRepository.update(request);
      return result;
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: error instanceof Error ? error.message : 'Unknown error occurred',
          },
        },
      };
    }
  }

  /**
   * 発注のreminderMailDataIdを一括更新する
   * @param updates - 更新対象の発注情報配列
   * @returns 更新結果
   */
  async ExecuteBulk(
    updates: Array<{
      orderId: string;
      reminderMailDataId: string | null;
      updateAt: number;
      orderNote?: string;
    }>
  ): Promise<INetworkResult<any, IError>> {
    // UpdateOrderInfoRequestを構築
    const updateOrderInfoRequest: BulkPutOrderRequest = {
      bulkPutOrderInfo: updates.map((update) => ({
        orderId: update.orderId,
        reminderMailDataId: update.reminderMailDataId,
        orderNote: update.orderNote,
        updateAt: update.updateAt,
      })),
    };

    try {
      const result = await this.orderRepository.bulkPut(updateOrderInfoRequest);
      return result;
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: error instanceof Error ? error.message : 'Unknown error occurred',
          },
        },
      };
    }
  }
}
